const MOCK_FLAG_ON = "1";

export const DEFAULT_SCENARIO = "default";

// Single local-only switch. Only the preview:mock script sets it, so every
// deployed build (test/stage/prod) leaves it undefined and uses the real APIs.
export const isMockMode = () =>
  process.env.REACT_APP_PREVIEW_MOCK === MOCK_FLAG_ON;

export const getMockScenario = (href = window.location.href) => {
  try {
    const scenario = new URL(href).searchParams.get("mock");
    return scenario || DEFAULT_SCENARIO;
  } catch (error) {
    return DEFAULT_SCENARIO;
  }
};
